import { modalInit } from '../modal.js'
import '../../utils/complianceChecker/index.js'
import { checkCompliance, manageCookiesTrigger } from '../../utils/complianceChecker/utils.js'

// YouTube sets targeting/advertising cookies, so the embed is gated behind
// that OneTrust category - confirm this matches the actual category ID
// configured in OneTrust's admin console for this site.
const REQUIRED_GROUPS = ['C0004']

const virtualTourInit = () => {
    const triggerWrappers = [...document.querySelectorAll('.js-virtual-tour-trigger-wrapper')]

    triggerWrappers.forEach((triggerWrapper) => {
        const gate = triggerWrapper.querySelector('.js-virtual-tour')
        if (!gate) return

        let activeGroups = []
        let isModalOpen = false

        const manageCookiesButton = gate.querySelector('.js-virtual-tour-manage-cookies')
        if (manageCookiesButton) manageCookiesTrigger(manageCookiesButton)

        // Loads the iframe as soon as both conditions are true - the modal is
        // actually open (kept lazy for visitors who never click the trigger)
        // and consent has been granted. Called from both the compliance
        // listener and onShow, since consent can change while the modal is
        // already sitting open (e.g. "Manage cookies" opens OneTrust's own
        // preference centre on top of it) - onShow alone would only ever
        // catch the state consent was in at the moment the modal opened.
        const loadIframeIfCompliant = () => {
            if (!isModalOpen || !checkCompliance(activeGroups, REQUIRED_GROUPS)) return

            const iframe = gate.querySelector('.js-virtual-tour-iframe')
            const videoId = gate.dataset.videoId
            if (!iframe || !videoId || iframe.getAttribute('src')) return

            iframe.setAttribute('src', `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1`)
        }

        window.addEventListener('complianceCheck', (e) => {
            activeGroups = e.detail?.activeGroups || []
            gate.dataset.compliant = checkCompliance(activeGroups, REQUIRED_GROUPS) ? 'true' : 'false'
            loadIframeIfCompliant()
        })

        modalInit(triggerWrapper, {
            onShow: () => {
                isModalOpen = true
                loadIframeIfCompliant()
            },
            onClose: () => {
                isModalOpen = false

                // Removing src stops the embedded YouTube player - it's moved
                // back to its original (hidden) location on close, same as
                // videoLeftViewport.js does for iframes leaving the viewport,
                // otherwise it just keeps playing invisibly in the background.
                const iframe = gate.querySelector('.js-virtual-tour-iframe')
                iframe?.removeAttribute('src')
            },
        })
    })
}
virtualTourInit()
